__webpack_require__.p = "http://localhost/prestashop817dev/themes/somness/assets/";